import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, createElementBlock as _createElementBlock, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  class: "container power-log"
};
const _hoisted_2 = {
  class: "handle-box"
};
const _hoisted_3 = {
  class: "pagination"
};
import { onMounted, ref } from "vue";
import { httpPost } from "@/utils/http";
import { ElMessage } from "element-plus";
import { dateFormat } from "@/utils/libs";
import { Search } from "@element-plus/icons-vue";
import Clipboard from "clipboard";
export default {
  __name: 'PowerLog',
  setup(__props) {
    const items = ref([]);
    const total = ref(0);
    const page = ref(1);
    const pageSize = ref(20);
    const loading = ref(false);
    const query = ref({
      model: "",
      date: [],
      type: 0
    });
    const totalPower = ref(0);
    const tagColors = ref(["", "success", "primary", "danger", "info", "warning"]);
    onMounted(() => {
      fetchData();
      const clipboard = new Clipboard(".copy-order-no");
      clipboard.on("success", () => {
        ElMessage.success("复制成功！");
      });
      clipboard.on("error", () => {
        ElMessage.error("复制失败！");
      });
    });

    // 搜索
    const search = () => {
      page.value = 1;
      fetchData();
    };

    // 获取数据
    const fetchData = () => {
      loading.value = true;
      httpPost("/admin/powerLog/list", {
        model: query.value.model,
        date: query.value.date,
        type: query.value.type,
        page: page.value,
        page_size: pageSize.value
      }).then(res => {
        const data = res.data.data;
        if (data) {
          items.value = data.items;
          total.value = data.total;
          page.value = data.page;
          pageSize.value = data.page_size;
        }
        totalPower.value = res.data.stat;
        loading.value = false;
      }).catch(e => {
        loading.value = false;
        ElMessage.error("获取数据失败：" + e.message);
      });
    };
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_date_picker = _resolveComponent("el-date-picker");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_tag = _resolveComponent("el-tag");
      const _component_el_text = _resolveComponent("el-text");
      const _component_el_table = _resolveComponent("el-table");
      const _component_el_pagination = _resolveComponent("el-pagination");
      const _component_el_row = _resolveComponent("el-row");
      const _component_el_empty = _resolveComponent("el-empty");
      const _directive_loading = _resolveDirective("loading");
      return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_input, {
        modelValue: query.value.model,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => query.value.model = $event),
        placeholder: "模型",
        class: "handle-input mr10",
        clearable: ""
      }, null, 8, ["modelValue"]), _createVNode(_component_el_select, {
        modelValue: query.value.type,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => query.value.type = $event),
        placeholder: "类别",
        style: {
          "width": "100px"
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_el_option, {
          label: "全部",
          value: 0
        }), _createVNode(_component_el_option, {
          label: "充值",
          value: 1
        }), _createVNode(_component_el_option, {
          label: "消费",
          value: 2
        }), _createVNode(_component_el_option, {
          label: "退款",
          value: 3
        }), _createVNode(_component_el_option, {
          label: "奖励",
          value: 4
        }), _createVNode(_component_el_option, {
          label: "众筹",
          value: 5
        })]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_el_date_picker, {
        modelValue: query.value.date,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => query.value.date = $event),
        type: "daterange",
        "start-placeholder": "开始日期",
        "end-placeholder": "结束日期",
        format: "YYYY-MM-DD",
        "value-format": "YYYY-MM-DD",
        style: {
          "margin": "0 10px",
          "width": "200px",
          "position": "relative",
          "top": "3px"
        }
      }, null, 8, ["modelValue"]), _createVNode(_component_el_button, {
        type: "primary",
        icon: _unref(Search),
        onClick: search
      }, {
        default: _withCtx(() => _cache[6] || (_cache[6] = [_createTextVNode("搜索")])),
        _: 1
      }, 8, ["icon"]), totalPower.value > 0 ? (_openBlock(), _createBlock(_component_el_button, {
        key: 0
      }, {
        default: _withCtx(() => [_createTextVNode("算力总额：" + _toDisplayString(totalPower.value), 1)]),
        _: 1
      })) : _createCommentVNode("", true)]), items.value.length > 0 ? (_openBlock(), _createBlock(_component_el_row, {
        key: 0
      }, {
        default: _withCtx(() => [_createVNode(_component_el_table, {
          data: items.value,
          "row-key": row => row.id,
          "table-layout": "auto",
          border: ""
        }, {
          default: _withCtx(() => [_createVNode(_component_el_table_column, {
            prop: "username",
            label: "用户"
          }), _createVNode(_component_el_table_column, {
            prop: "model",
            label: "模型"
          }), _createVNode(_component_el_table_column, {
            prop: "type",
            label: "类型"
          }, {
            default: _withCtx(scope => [_createVNode(_component_el_tag, {
              size: "small",
              type: tagColors.value[scope.row.type]
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(scope.row.type_str), 1)]),
              _: 2
            }, 1032, ["type"])]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            label: "数额"
          }, {
            default: _withCtx(scope => [_createElementVNode("div", null, [scope.row.mark === 1 ? (_openBlock(), _createBlock(_component_el_text, {
              key: 0,
              type: "success"
            }, {
              default: _withCtx(() => [_createTextVNode("+" + _toDisplayString(scope.row.amount), 1)]),
              _: 2
            }, 1024)) : _createCommentVNode("", true), scope.row.mark === 0 ? (_openBlock(), _createBlock(_component_el_text, {
              key: 1,
              type: "danger"
            }, {
              default: _withCtx(() => [_createTextVNode("-" + _toDisplayString(scope.row.amount), 1)]),
              _: 2
            }, 1024)) : _createCommentVNode("", true)])]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            prop: "balance",
            label: "余额"
          }), _createVNode(_component_el_table_column, {
            label: "发生时间"
          }, {
            default: _withCtx(scope => [_createElementVNode("span", null, _toDisplayString(_unref(dateFormat)(scope.row["created_at"])), 1)]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            prop: "remark",
            label: "备注"
          })]),
          _: 1
        }, 8, ["data", "row-key"]), _createElementVNode("div", _hoisted_3, [total.value > 0 ? (_openBlock(), _createBlock(_component_el_pagination, {
          key: 0,
          background: "",
          layout: "total,prev, pager, next",
          "hide-on-single-page": true,
          "current-page": page.value,
          "onUpdate:currentPage": _cache[3] || (_cache[3] = $event => page.value = $event),
          "page-size": pageSize.value,
          "onUpdate:pageSize": _cache[4] || (_cache[4] = $event => pageSize.value = $event),
          onCurrentChange: _cache[5] || (_cache[5] = $event => fetchData()),
          total: total.value
        }, null, 8, ["current-page", "page-size", "total"])) : _createCommentVNode("", true)])]),
        _: 1
      })) : (_openBlock(), _createBlock(_component_el_empty, {
        key: 1,
        "image-size": 100
      }))])), [[_directive_loading, loading.value]]);
    };
  }
};